export default direction => ({
    left: 'right',
    right: 'left',
    top: 'bottom',
    bottom: 'top',
}[direction])